import React, { useState } from "react";
import { FaSpinner, FaTimes } from "react-icons/fa";
import {  useDispatch, useSelector } from "react-redux";

import { BsExclamationLg } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import { formatNumberWithCommas } from "../../../utils/commonUtils";
import { cancelManualTransfer, fetchManualTransfer } from "../../../redux/slices/manualTransferSlice";
import { pushNotifyUser } from "../../../redux/slices/pushSlice";
import { toast } from "react-toastify";

export default function CancelCartShoppingManualTransfer({
  id,
  name,
  amount,
  user_id,
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const status = useSelector((state) => state.payment?.status);

  const dispatch = useDispatch();

  const handleCancel = async () => {
    try {
      const res = await dispatch(cancelManualTransfer(id));
      if (res.payload) {
        const pushNote = {
          user_id: [user_id],
          title: "Capfields Evolve",
          body: `Your payment of ₦${amount} for Cart Shopping has been canceled.`,
          click: "USER",
        };
        dispatch(pushNotifyUser(pushNote));
        await dispatch(fetchManualTransfer());
        toast.success(res.payload.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while cancelling.");
    }
    setShowCancelModal(false);
  };

  return (
    <>
      <div className="flex items-center">
        <button type="button" onClick={() => setShowConfirmModal(true)}>
          <MdCancel className="text-red-600 text-2xl" />
        </button>
      </div>

      {showConfirmModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="bg-white p-12 rounded-lg shadow-lg relative max-w-md w-full">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="absolute top-3 right-2.5 text-gray-400 hover:text-gray-900"
              >
                <FaTimes />
              </button>
              <h1 className="text-2xl mb-4 font-semibold text-gray-800 text-center">
                Are you sure?
              </h1>
              <p className="text-center text-sm mb-4">
                Do you really want to cancel this Cart Shopping transaction?
              </p>
              <div className="flex justify-center mb-4">
                <BsExclamationLg className="text-gray-500 text-3xl" />
              </div>
              <div className="flex gap-4 justify-center">
                <button
                  onClick={() => setShowConfirmModal(false)}
                  className="px-4 py-2 bg-gray-100 text-sm font-semibold text-gray-500 rounded-md"
                >
                  Close
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    setShowCancelModal(true);
                  }}
                  className="px-4 py-2 bg-red-600 text-white text-sm font-semibold rounded-md"
                >
                  Yes, Cancel It
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}

      {showCancelModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="bg-white p-12 rounded-lg shadow-lg relative max-w-lg w-full">
              <button
                onClick={() => setShowCancelModal(false)}
                className="absolute top-3 right-2.5 text-gray-400 hover:text-gray-900"
              >
                <FaTimes />
              </button>
              <h1 className="text-2xl font-medium text-center text-gray-800 mb-2">
                Cancel Cart Shopping Transfer
              </h1>
              <p className="text-center mb-4">
                Confirm you want to cancel this transfer.
              </p>
              <div className="flex flex-col gap-4 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-500">User Name:</span>
                  <span className="font-semibold">{name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-500">Amount:</span>
                  <span className="font-semibold">
                    ₦{formatNumberWithCommas(amount)}
                  </span>
                </div>
              </div>
              <div className="flex justify-center gap-4 mt-6">
                <button
                  onClick={() => setShowCancelModal(false)}
                  className="text-sm text-gray-500 font-semibold bg-gray-100 py-2 px-4 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={handleCancel}
                  disabled={status === "loading"}
                  className="flex gap-1 items-center bg-red-600 text-white py-2 px-4 rounded-md"
                >
                  {status === "loading" ? (
                    <>
                      <FaSpinner className="animate-spin" />
                      <span className="text-sm font-semibold">Cancelling...</span>
                    </>
                  ) : (
                    <>
                      <FaTimes className="w-4 h-4" />
                      <span className="text-sm font-semibold">Cancel Now</span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      )}
    </>
  );
}
